import { styled } from '@mui/material/styles';

// eslint-disable-next-line import/prefer-default-export
export const EngineOptions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '& label.checkbox-label': {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),

    '& svg': {
      marginRight: theme.spacing(1),
      marginBottom: '-2px',
      width: '15px',
    },
  },
}));
